import { useMutation, useQuery, UseQueryResult } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
import { GatewaysResponse } from "../types/GetGatewayType";
import { QurePocResponse } from "../types";

export const useGetGateways = (
  isOpen: boolean
): UseQueryResult<GatewaysResponse, Error> => {
  return useQuery<GatewaysResponse, Error>(
    ["gateways", isOpen],
    () => {
      return servicesUtils.getService(`/profile/gateways/`);
    },
    {
      enabled: isOpen,
    }
  );
};

export const useGetPOCNumber = (
  isOpen: boolean
): UseQueryResult<QurePocResponse, Error> => {
  return useQuery<QurePocResponse, Error>(
    ["poc_phone", isOpen],
    () => {
      return servicesUtils.getService(`/profile/poc_phone/`);
    },
    {
      enabled: isOpen,
    }
  );
};

export const useAddQurePOCNumber = () => {
  return useMutation((params: { phone: string }) =>
    servicesUtils.postService(`/profile/poc_phone/`, params)
  );
};

export const useAddITPOCNumber = () => {
  return useMutation((params: { phone: string; gateway_id: string }) =>
    servicesUtils.postService(`/gateway/${params?.gateway_id}/poc_phone/`, {
      phone: params?.phone,
    })
  );
};
